import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';

type Props = {
  helpCenterUrl?: string;
  linkText: string;
};

export default function HelpCenterLink({ helpCenterUrl, linkText }: Props) {
  if (!helpCenterUrl) return null;

  return (
    <a
      className="mt-4 mb-4 d-inline-block"
      href={helpCenterUrl}
      rel="noopener noreferrer"
      target="_blank"
    >
      <FontAwesomeIcon className="me-2" icon={faQuestionCircle}/>
      {linkText}
    </a>
  );
}
